<template lang="pug">
  el-container(id="ClientEdit-container")
    el-dialog(id="ClientEdit-dialogWrapper" :close-on-click-modal="false", :visible.sync="mutableEditDialogVisible", fullscreen=false, :title="$t('Edit client')", :before-close="beforeCloseHandler", append-to-body)
      el-form(
        id="ClientEdit-form",
        :model="clientData",
        :rules="rules",
        ref="clientForm",
        label-width="320px",
        status-icon=true,
        :size="uxParam('formSize')",
        v-loading="loading",
      )
        el-form-item(:label="$t('Client name')", prop="name")
          el-input(id="ClientEdit-formNameInput" v-model='clientData.name')
        el-form-item(:label="$t('Password valid days (0 - unlimited)')", prop="name")
          el-input-number(id="ClientEdit-formPasswordValidInput" v-model='clientData.passwordValidDays')
      .dialog-footer(slot="footer")
        el-button(
          id="ClientEdit-formSaveButton",
          type="primary",
          @click="submitForm('clientForm')"
          :circle="uxParam('buttonCircle')",
          :round="uxParam('buttonRound')",
          :plain="uxParam('buttonPlain')",
          :disabled="loading"
        ) {{$t('Save')}}
        el-button(
          id="ClientEdit-formCancelButton",
          @click='mutableEditDialogVisible = false'
          :circle="uxParam('buttonCircle')",
          :round="uxParam('buttonRound')",
          :plain="uxParam('buttonPlain')"
        ) {{$t('Cancel')}}
</template>

<script>

export default {
  props: {
    'clientId': {
      required: true
    },
    'editDialogVisible': {
      required: true
    }
  },
  data () {
    return {
      loading: true,
      clientData: {
        id: 0,
        name: '',
        Networks: null,
        NetworkIds: [],
        Users: null,
        UserIds: []
      },
      rules: {
        name: [
          { required: true, message: this.$t('Please enter client name'), trigger: 'blur' },
          { min: 3, max: 255, message: this.$t('Length should be 3 to 255'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    clientId: async function (newVal, oldVal) {
      this.loading = true
      this.clientData = {
        id: 0,
        name: '',
        Networks: null,
        NetworkIds: [],
        Users: null,
        UserIds: []
      }

      this.$nextTick(function () {
        this.$refs['clientForm'].resetFields()
      })

      if (this.clientId !== null && this.clientId !== 0) {
        let clientData = await this.$store.dispatch('Client/getClientData', {
          data: {
            clientId: this.clientId
          }
        })
        this.clientData = JSON.parse(JSON.stringify(clientData))
      }

      this.loading = false
    }
  },
  methods: {
    async submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(this.clientId === 0 ? 'Client/createClientData' : 'Client/updateClientData', {
            data: JSON.parse(JSON.stringify(this.clientData))
          })
            .then(response => {
              this.mutableEditDialogVisible = false
              this.loading = false
            })
            .catch(error => {
              console.log(error.response.status)
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    beforeCloseHandler: function (done) {
      done()
    }
  },
  computed: {
    mutableEditDialogVisible: {
      get: function () {
        return this.editDialogVisible
      },
      set: function (value) {
        this.$emit('closeEditDialog', value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Client/ClientEdit.vue